import * as React from "react"
import { Button, Flex } from "@chakra-ui/react"
import { FaRegMinusSquare, FaRegPlusSquare } from "react-icons/fa"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useTranslation } from "react-i18next"

interface MouseHoverButtonsProps {
  isPublished: boolean
  isHovered: boolean
  isChat?: boolean
  toggleOverlay: any
  additionalButtons?: React.ReactNode
  isHistoryBadge?: boolean
  positionX?: string
  widthButton?: string
  isSmallIndex?: boolean
  heightHoverButton?: string
  alignButtons?: string
  displaySmall?: boolean
}

export const MouseHoverButtons = ({
  isPublished,
  isHovered,
  toggleOverlay,
  isChat,
  additionalButtons = null,
  isHistoryBadge,
  positionX,
  widthButton,
  alignButtons,
  heightHoverButton,
  displaySmall,
}: MouseHoverButtonsProps) => {
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)
  const text = React.useMemo<string>(() => {
    if (isHistoryBadge) {
      return t("Delete")
    }
    return isPublished ? t("Hide") : t("Show")
  }, [isHistoryBadge, isPublished, t])

  const icon = React.useMemo(() => {
    if (isHistoryBadge) {
      return null
    }
    return isPublished ? <FaRegMinusSquare /> : <FaRegPlusSquare />
  }, [isHistoryBadge, isPublished])

  if (!isHovered) return null

  return (
    <Flex
      position="absolute"
      top="0"
      left={positionX ?? "0"}
      w="100%"
      h={heightHoverButton ?? "100%"}
      opacity="1"
      justifyContent={"center"}
      gap={displaySmall ? ".3rem" : ".5rem"}
      alignItems={alignButtons ?? "center"}
      zIndex="1000000"
    >
      {additionalButtons && additionalButtons}
      <Button
        leftIcon={icon}
        iconSpacing={displaySmall ? ".25rem" : undefined}
        bg={roomStyles?.secondaryAccessButtonBackgroundColor ?? "#1AC541"}
        border={
          roomStyles?.secondaryAccessButtonBorderColor
            ? `1px solid ${
                roomStyles?.secondaryAccessButtonBorderColor
                  ? roomStyles.secondaryAccessButtonBorderColor
                  : "transparent"
              }`
            : "0px"
        }
        textColor={roomStyles?.secondaryAccessButtonTextColor ?? "#FFFFFF"}
        _hover={{
          backgroundColor:
            roomStyles?.secondaryAccessButtonMouseoverColor ?? "#24A840",
          textColor:
            roomStyles?.secondaryAccessButtonTextMouseoverColor ?? "#FFFFFF"
        }}
        type="button"
        fontWeight="bold"
        onClick={toggleOverlay}
        _focus={{}}
        zIndex="10000"
        minWidth={displaySmall ? "unset" : widthButton ?? "96px"}
        padding={displaySmall ? ".65rem" : undefined}
        height={displaySmall ? "unset" : undefined}
        fontSize={
          displaySmall
            ? "0.6rem"
            : isChat && additionalButtons
            ? "0.75rem"
            : "md"
        }
      >
        {text}
      </Button>
    </Flex>
  )
}

export default MouseHoverButtons
